import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import Icon from 'src/components/common/Icon';
import { AppDispatch } from 'src/store';
import { setShowInfoPopup } from 'src/store/ui';
import { unlockBodyScroll } from 'src/utils/block-body-scroll';

import css from './InfoPopup.module.scss';

interface Props {
  className?: string;
}

const title = 'איך זה עובד?';
const p1 = `משחק המאצ׳ הפוליטי של N12, בשיתוף עמותת 121, בוחן את עמדות המפלגות בנושאים המרכזיים בבחירות 2026. ערכנו בדיקת עומק של עמדות המפלגות באמצעות סקירה של מצעים, התחייבויות רשמיות, התבטאויות פומביות של ראשי המפלגות ובכירים בהן בתקשורת וברשתות החברתיות. במקרים שבהם לא מצאנו עמדה ברורה ומובהקת, פנינו ישירות למפלגה לקבלת התייחסות.`;
const p2 = `בדקנו עשרות נושאים. לגבי כל אחד מהם סיווגנו את עמדת המפלגה על סולם של ארבע דרגות: תומכת (100), תומכת חלקית (66), מתנגדת חלקית (33) או מתנגדת (0). הגולשים מתבקשים לבחור אם הם מסכימים (100) או אינם מסכימים (0) עם כל היגד. ציון ההתאמה בכל היגד נקבע לפי הפער בין תשובת הגולש לעמדת המפלגה: ככל שהפער קטן יותר, כך ההתאמה גבוהה יותר. הסכמה מלאה מעניקה ציון 100, ואילו עמדות הפוכות לחלוטין מעניקות ציון 0.
בסיום, ציוני ההתאמה בכל ההיגדים משוקללים לציון ההתאמה הכולל של הגולש עם כל אחת משתי המפלגות. למשחק נבחרים רק היגדים שלגביהם קיימת עמדה מתועדת של שתי המפלגות שנבחרו להשוואה. עמותת "121 - מנוע לשינוי חברתי" עוקבת איתנו אחרי הבטחות הבחירות בנושאים החברתיים. <b>הממשק מציג מפלגות שעוברות 1% עפ"י ממוצע סקרים נכון ל-1.10.26, הרשימה תתעדכן בהתאם לשינויים בסקרים ובהרכב הרשימות</b>`;

const InfoPopup: React.FC<Props> = () => {
  const dispatch = useDispatch<AppDispatch>();
  const containerRef = useRef<HTMLDivElement>(null);

  const onCloseClick = () => {
    dispatch(setShowInfoPopup(false));
    unlockBodyScroll();
  };

  const renderContent = () => {
    return (
      <div className={css.contentInner}>
        <div className={css.scrollable}>
          <h6 className={css.title}>{title}</h6>
          <p className={css.p}>{p1}</p>
          <p className={css.p} dangerouslySetInnerHTML={{ __html: p2 }} />
        </div>
      </div>
    );
  };

  return (
    <div className={css.popup}>
      <div className={css.popupOverlay} onClick={onCloseClick} />
      <div className={css.popupContent} ref={containerRef}>
        <button className={css.closeBtn} onClick={onCloseClick}>
          <Icon type="close" />
        </button>
        {renderContent()}
      </div>
    </div>
  );
};

export default InfoPopup;
